import React from 'react';
import {getPageDescription} from 'util/locationUtil';
import {useLocation} from 'react-router-dom';

const QuestionMark = () => {
    const location = useLocation();

    function getTooltipText() {
        return getPageDescription(location.pathname);
    }

    return (
        <div
            className="question-mark-icon"
            data-tooltip-id="main-tooltip"
            data-tooltip-content={getTooltipText()}
        >
            ?
        </div>
    );
};

export default QuestionMark;